var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C7.84359 35 0 27.1564 0 17.5C0 7.84359 7.84359 0 17.5 0C27.1564 0 35 7.84359 35 17.5C35 27.1564 27.1564 35 17.5 35ZM17.5 1.79487C8.83077 1.79487 1.79487 8.83077 1.79487 17.5C1.79487 26.1692 8.83077 33.2051 17.5 33.2051C26.1692 33.2051 33.2051 26.1692 33.2051 17.5C33.2051 8.83077 26.1692 1.79487 17.5 1.79487Z",
    fill: "#30313A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 26.223L7.07192 14.5743C6.74884 14.1974 6.76679 13.641 7.14371 13.3C7.50269 12.9769 8.07705 12.9948 8.41807 13.3718L17.5181 23.5307L26.7258 13.3538C27.0668 12.9948 27.6232 12.9589 28.0001 13.282C28.3591 13.623 28.395 14.1794 28.0719 14.5564L17.536 26.2051L17.5001 26.223Z",
    fill: "#30313A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.2e2e5f2c8d376be9e936e69b3eca7a1a.svg";
export { ForwardRef as ReactComponent };